// componnet
import { ArrowRightIcon } from "../kits/Icons/Icons";
import { CustomInput } from "../kits/inputs/Input";
import { SortIcon } from "../kits/Icons/Icons";
import { CloseIcon } from "../kits/Icons/Icons";
import Drawer from "../drawer/Drawer";
import useAxios from "../../services/useAxios";
import ProductCard from "../common/ProductCard/ProductCard";
import Loader from "../kits/Loader";
import ShoppingCartItemContext from "../../context/ShoppingCart/ShoppingCartItemContext";
import CloseDrawer from "../ShopPage/CloseDrawer/CloseDrawer";
import CartItemBtn from "../cartitem/CartitemBtn";
import { pathMaker } from "../../utilities/helperFunctions";
// style
import "./StoreSearch.scss";
import colorschema from "../../assets/kits/colors/colors.module.scss";
// import useWindowSize from "hooks/useWindowSize";
import useWindowSize from "../../hooks/useWindowSize";
// react imports
import { NavLink } from "react-router-dom";
import { useState, useMemo, useEffect, useRef, useContext } from "react";
import { useParams } from "react-router-dom";
import { debounce } from "lodash";

export default function StoreSearch() {
  const [loading, setLoading] = useState(false);
  const shopId = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const [sortType, setSortType] = useState(-1);
  const [searchTitle, setSearchTitle] = useState([]);
  const [counter, setCounter] = useState(0);
  const [resulte, steResult] = useState([{ title: "تخم مرغ" }]);
  const [nameStore, setNameStore] = useState([]);
  const [shopIsOpen, setShopISOpen] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [isOpenDrawerClose, setIsOpenDrawerClose] = useState(false);
  const { width } = useWindowSize();
  const [detailProduct, setDetailProduct] = useState([-1]);
  const [click, setClick] = useState(false);
  const {
    getItemCountPerShop,
    changeShoppingCartItemCount,
    shoppingListItemsFinalState,
  } = useContext(ShoppingCartItemContext);

  const count = getItemCountPerShop(shopId.storeId);
  // const count = getItemCountPerShop(shopId)[`apoId_${shopId.storeId}`];
  const shoppingCartState = shoppingListItemsFinalState;

  const productCardWidth = useMemo(() => {
    // console.log("width", width);
    return width >= 445 ? 130 : width >= 375 ? 160 : 130;
  }, [width]);

  const situationShopFunc = (
    startHour,
    startMin,
    finishHour,
    finishMin,
    status
  ) => {
    let situation = <></>;
    let currentHour = new Date().getHours();
    let currentMin = new Date().getMinutes();
    if (
      currentHour < startHour ||
      currentHour > finishHour ||
      (currentHour == startHour && currentMin < startMin) ||
      (currentHour == finishHour && currentMin > finishMin) ||
      status != 0
    ) {
      setShopISOpen(false);
    } else if (
      (currentHour > startHour && currentHour < finishHour) ||
      (currentHour == startHour &&
        currentMin > startMin &&
        currentHour < finishHour) ||
      (currentHour == finishHour &&
        currentMin < finishMin &&
        currentHour > startHour)
    ) {
      setShopISOpen(true);
    }
  };
  const { execute: SearchStore } = useAxios("supplier/search_products");

  const searchDebounce = useRef(
    debounce((text) => {
      if (text !== "") {
        SearchStoreFun(text);
      } else {
        setDetailProduct([-1]);
      }
    }, 2000)
  );

  async function SearchStoreFun(search_text, search_type) {
    setLoading(true);
    await SearchStore({
      supplier_id: shopId.storeId,
      search_text: search_text,
      ...(search_type != undefined && { search_type }),
    }).then((res) => {
      if (res.status == 1) {
        setDetailProduct(res.data);
        setLoading(false);
      }
    });
  }

  const { execute: searcName } = useAxios("supplier/Find_suppliers");

  async function searchNameFun() {
    await searcName({
      conditions: `id/=/${shopId.storeId}`,
    }).then((res) => {
      setNameStore(res[0].title);
      situationShopFunc(
        res[0]?.start_hour,
        res[0]?.start_min,
        res[0]?.finish_hour,
        res[0]?.finish_min,
        res[0]?.main_status
      );
    });
  }

  useEffect(() => {
    searchNameFun();
  }, []);

  return (
    <div className="store-search  d-flex flex-column">
      <div className="d-flex justify-content-start pd-y-12 pd-x-20  border-0 mr-b-8 ">
        <div
          style={{ cursor: "pointer" }}
          onClick={() => {
            window.history.back();
          }}
        >
          <ArrowRightIcon></ArrowRightIcon>
        </div>
      </div>
      <div className="d-flex search pd-x-20">
        <CustomInput
          placeholder={`جستجو در ${nameStore}`}
          haveIcon
          style={{ backgroundColor: colorschema.schema_surface_light }}
          value={searchTitle.title}
          onChange={(e) => {
            searchDebounce.current(e.target.value);

            setSearchTitle((prev) => {
              return { title: e.target.value };
            });
          }}
        ></CustomInput>
        {searchTitle.length >= 0 ||
          (searchTitle.title != "" && (
            <div
              className="d-flex justify-content-center"
              style={{ alignItems: "center", cursor: "pointer" }}
              onClick={(e) => {
                setDetailProduct([-1]);

                setSearchTitle((prev) => {
                  return { title: "" };
                });
              }}
            >
              <button className="btn-cansel txt-t1-m mr-r-12 ">
                <p className="mr-r-12 mr-l-12">انصراف</p>
              </button>
            </div>
          ))}
      </div>
      {loading ? (
        // <div className="d-flex text-align-centre align-items-center justify-content-center h-100">
        <div className="text-center d-flex flex-column align-items-center justify-content-center flex-grow-1">
          <div className="box-loader "></div>
          <Loader width={40}></Loader>
        </div>
      ) : (
        <>
          <div className="d-flex mr-t-20 pd-x-20">
            {/* <div className="d-flex box-sort" */}
            {detailProduct != -1 ? (
              <>
                {" "}
                {detailProduct.length > 0 && (
                  <>
                    <div
                      style={{ cursor: "pointer" }}
                      className={`d-flex box-sort ${
                        sortType != -1 && "active-sort"
                      }`}
                    >
                      <div
                        className="mr-y-8"
                        style={{ width: "16px", height: "16px" }}
                        onClick={(e) => {
                          setIsOpen(true);
                        }}
                      >
                        {sortType == 0 || sortType == 1 ? (
                          <SortIcon
                            iconClassName="active-icon"
                            width="16px"
                            height="16px"
                          ></SortIcon>
                        ) : (
                          <SortIcon></SortIcon>
                        )}
                      </div>
                      <div
                        className={`mr-r-6 desc-m ${
                          sortType != -1 && "active-title d-flex  desc-m"
                        }`}
                        onClick={(e) => {
                          setIsOpen(true);
                        }}
                      >
                        <>
                          {sortType != -1 ? (
                            <> مرتب سازی بر اساس: &nbsp;</>
                          ) : (
                            <> مرتب سازی بر اساس &nbsp;</>
                          )}
                          {sortType == 0 ? (
                            <div className="d-flex">
                              {/* <div className="">:</div> */}
                              <>ارزان ترین</>{" "}
                            </div>
                          ) : (
                            sortType == 1 && <> گران ترین </>
                          )}
                        </>
                      </div>
                      <Drawer
                        isOpen={isOpen}
                        onClose={() => {
                          setIsOpen(false);
                        }}
                        height={178}
                      >
                        <div className="pd-x-20 parent-drawer">
                          <div className="demo-content">
                            <div className="title mr-t-16 title-h4-m">
                              {" "}
                              مرتب سازی براساس{" "}
                            </div>
                            <div className="mr-t-16 ">
                              <div
                                className="d-flex item-sort  pd-t-12 pd-b-12 txt-t2-l"
                                style={{ cursor: "pointer" }}
                                onClick={(e) => {
                                  setSortType(0);
                                  SearchStoreFun(searchTitle.title, 0);
                                  setIsOpen(false);
                                }}
                              >
                                ارزان ترین
                              </div>
                              <div
                                className="d-flex item-sort  pd-t-12 pd-b-12 mr-t-8 txt-t2-l"
                                style={{ cursor: "pointer" }}
                                onClick={(e) => {
                                  setSortType(1);
                                  SearchStoreFun(searchTitle.title, 1);

                                  setIsOpen(false);
                                }}
                              >
                                گران ترین
                              </div>
                            </div>
                          </div>
                        </div>
                      </Drawer>
                      <>
                        {sortType != -1 && (
                          <div
                            className="mr-r-6"
                            onClick={(e) => {
                              setSortType(-1);
                              SearchStoreFun(searchTitle.title, -1);
                              setLoading(true);
                            }}
                          >
                            {/* <div
                              onClick={() => {
                              }}
                            > */}
                            <CloseIcon
                              iconClassName="active-icon"
                              width="16px"
                              height="16px"
                            ></CloseIcon>
                            {/* </div> */}
                          </div>
                        )}
                      </>
                    </div>
                  </>
                )}
              </>
            ) : (
              <></>
            )}
          </div>

          {detailProduct != -1 ? (
            <>
              {detailProduct.length > 0 ? (
                <>
                  <div
                    className="  pd-x-20  grid-group"
                    style={{
                      paddingBottom: Object.keys(count).length !== 0 ? 75 : 0,
                    }}
                  >
                    {detailProduct?.map((val, ind) => {
                      return (
                        <div className="mr-t-20 " style={{ cursor: "pointer" }}>
                          <ProductCard
                            title={val.product_info.title}
                            link={`/product/${shopId.storeId}/${val.id}`}
                            price={val.price}
                            cartItemCount={count[`apoId_${val.id}`]}
                            imagePath={pathMaker(val.product_info.path)}
                            key={`product-card-${1}`}
                            disabled={!shopIsOpen}
                            discount={val.discount}
                            disableOnClick={() => {
                              if (!shopIsOpen) {
                                setIsOpenDrawerClose(true);
                              }
                            }}
                            plusOnClick={() => {
                              setClick(true);
                              changeShoppingCartItemCount(
                                "add",
                                "",
                                val.total_inventory_count,
                                val.min_order_count,
                                getItemCountPerShop(shopId.storeId)[
                                  `apoId_${val.id}`
                                ],
                                "1",
                                val.product_info.price,
                                val.id,
                                val.product_info.title,
                                shopId.storeId
                              );
                            }}
                            minusOnClick={() => {
                              changeShoppingCartItemCount(
                                "reduce",
                                "",
                                val.total_inventory_count,
                                val.min_order_count,
                                "",
                                "1",
                                val.product_info.price,
                                val.id,
                                val.product_info.title,
                                shopId.storeId
                              );
                            }}
                            width={productCardWidth}
                            loading={
                              shoppingCartState[`state-${val.id}`] == true
                                ? true
                                : false
                            }
                          />
                        </div>
                      );
                    })}
                  </div>
                </>
              ) : (
                <div className="text-center d-flex flex-column align-items-center justify-content-center flex-grow-1">
                  {/* <div className="box "></div> */}
                  <div className="message mr-t-12 desc-c-l">
                    محصولی در سوپر مارکت &nbsp;{nameStore} مشابه&nbsp;
                    {searchTitle.title} &nbsp;وجود ندارد
                  </div>
                </div>
              )}
            </>
          ) : (
            <></>
          )}
        </>
      )}

      <div>
        <CloseDrawer
          isOpen={isOpenDrawerClose}
          setIsOpen={setIsOpenDrawerClose}
          shopName={nameStore}
        ></CloseDrawer>
      </div>
      {Object.keys(count).length !== 0 && (
        <div className="mr-t-12">
          <CartItemBtn isOpen2={true} height={72} shopId={shopId.storeId} />
        </div>
      )}
    </div>
  );
}
